export function scheduleNonCriticalTask(task, { timeout = 2500, fallbackDelay = 0, delay = 0 } = {}) {
  if (delay > 0) {
    return setTimeout(() => {
      scheduleNonCriticalTask(task, { timeout, fallbackDelay, delay: 0 })
    }, delay)
  }

  if (typeof window.requestIdleCallback === 'function') {
    return window.requestIdleCallback(task, { timeout })
  }

  if (fallbackDelay === null) {
    return task()
  }

  return setTimeout(task, fallbackDelay)
}
